import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Grid } from '@mui/material';
import Typographys from 'components/Atoms/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import { useTheme } from '@mui/material/styles';
import TitleWithText from 'components/Atoms/TitleWithText';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Button from 'components/Atoms/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import ToolTip from 'components/Atoms/ToolTip';

import ChooseFile from 'components/Atoms/ChooseFile';
import { myPayStyle } from './style';
import { validateNumberElseHyphen } from '../../../../utils/commonUtils';

const UploadInvestmentProofs = ({
  formData,
  employeeDetails,
  handleCancel,
  handleUpload,
  handleDelete,
  handleDeleteFile,
  handleDownloadFile,
  handleSubmitProofs,
  userHasProofSubmitPermission,
  userhasProofUploadPermission,
}) => {
  const theme = useTheme();
  const [data, setData] = useState(formData);
  const [file, setFile] = useState('');
  const [files, setFiles] = useState({});
  const handleFileChange = (event) => {
    const file1 = event.target.files[0];
    setFile(file1);
  };

  const handleChange = (event, index) => {
    const file1 = event.target.files[0];
    setFiles({ ...files, [index]: file1 });
  };
  return (
    <Box>
      <PerfectScrollbar>
        <Box sx={{ maxHeight: 'calc(100vh - 33.3rem)' }}>
          <Grid container rowSpacing={2} columnSpacing={4}>
            <Grid item xs={12} sm={4} lg={3}>
              <TitleWithText title="Employee*" text={employeeDetails.name} />
            </Grid>

            <Grid item xs={12} sm={4} lg={3}>
              <TitleWithText title="Employee ID*" text={employeeDetails.eid} />
            </Grid>

            <Grid item xs={12} sm={4} lg={3}>
              <TitleWithText title="Financial Year*" text={employeeDetails.financialYear} />
            </Grid>

            <Grid item xs={12} sm={12} lg={3}>
              <TitleWithText title="Assesment Year*" text={employeeDetails.assesmentYear} />
            </Grid>
          </Grid>

          <Box sx={myPayStyle.chooseFileWrapper}>
            <Typographys>FORM 12BB (Signed and scanned copy) (Mandatorily Required) **</Typographys>
            {!file && (
              <ChooseFile
                handleChange={(e) => {
                  handleChange(e, 'form12bb');
                }}
                value={files?.form12bb}
                name="file1"
                id="file2"
                showNoFileTitle
              />
            )}

            {file && (
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  variant="text"
                  color="secondary"
                  onClick={() => {
                    handleDownloadFile(file);
                  }}
                >
                  {file.name}
                </Button>
                <DeleteIcon onClick={handleDelete} color="action" />
              </Box>
            )}
          </Box>

          <Typographys variant="caption" color="neutral.600">
            ** You can download your Form 12BB from My Pay -&gt; Form 12BB on the main Menu.
          </Typographys>

          <Box mt={2} sx={myPayStyle.tableWrapper}>
            <Table className={myPayStyle.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Sl No</TableCell>
                  <TableCell>Investment/Deduction Head</TableCell>
                  <TableCell>Actual Declared Amount</TableCell>
                  <TableCell>Upload Investment Proofs</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((row, index) => {
                  return (
                    <TableRow>
                      <TableCell className={myPayStyle.tableCell}>
                        <Typographys variant="body2">{index + 1}</Typographys>
                      </TableCell>
                      <TableCell>
                        <Typographys variant="body2">
                          {row.investmentHead}
                          <ToolTip tooltipTitle={row.dataContent} title={row.dataOriginalTitle} placement="top" />
                        </Typographys>
                      </TableCell>
                      <TableCell>
                        <Typographys variant="body2">{validateNumberElseHyphen(row.actualDeclairedAmount)}</Typographys>
                      </TableCell>
                      <TableCell variant="body2">
                        {!row?.file && (
                          <ChooseFile
                            handleChange={(e) => {
                              handleChange(e, row?.deductionHeadID);
                            }}
                            value={files?.[row?.deductionHeadID]}
                            showNoFileTitle
                          />
                        )}

                        {row?.file && (
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button
                              variant="text"
                              color="secondary"
                              onClick={() => {
                                handleDownloadFile(row?.file);
                              }}
                            >
                              {row?.file.name}
                            </Button>

                            <DeleteIcon onClick={handleDeleteFile} color="action" />
                          </Box>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </PerfectScrollbar>

      <Box sx={myPayStyle.btnContainer}>
        <Divider sx={{ my: 2, backgroundColor: theme.palette.neutral[200] }} />

        <Box sx={myPayStyle.submitWrapper}>
          <Button
            size="large"
            color="info"
            variant="outlined"
            type="button"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </Button>

          {!!userHasProofSubmitPermission && (
            <Button
              size="large"
              color="info"
              variant="outlined"
              type="button"
              onClick={() => {
                handleSubmitProofs();
              }}
            >
              Submit Investment Proofs
            </Button>
          )}

          {!!userhasProofUploadPermission && (
            <Button
              onClick={() => {
                handleUpload({ files });
              }}
              size="large"
              type="submit"
              disable={false}
            >
              Upload Proofs
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};
UploadInvestmentProofs.defaultProps = {
  formData: [],
  employeeDetails: {},
  handleCancel: () => {},
  handleUpload: () => {},
  handleDelete: () => {},
  handleDeleteFile: () => {},
  handleDownloadFile: () => {},
};

UploadInvestmentProofs.propTypes = {
  formData: PropTypes.arrayOf(),
  employeeDetails: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    financialYear: PropTypes.string,
    assesmentYear: PropTypes.string,
  }),
  handleCancel: PropTypes.func,
  handleUpload: PropTypes.func,
  handleDelete: PropTypes.func,
  handleDeleteFile: PropTypes.func,
  handleDownloadFile: PropTypes.func,
};
export default UploadInvestmentProofs;
